import type { CityConfig } from "../city-template/types";

export const brightonConfig: CityConfig = {
  city: "Brighton",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "brighton",
  route: "/cities/brighton",
  title: "Emergency & Expedited Passport Brighton CO | Same-Day Adams County | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Brighton, Colorado — as fast as 24 hours. Same-day courier processing for Brighton, Commerce City, Fort Lupton, Henderson, Lochbuie, and all Adams County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Brighton, CO",
  heroSubtitle: "Planning international travel from DIA and just discovered your passport is expired? Business trip to Mexico or Canada coming up fast? We help Brighton residents — from Bromley Park families to Adams County professionals to Barr Lake outdoor enthusiasts — get their passports quickly. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Brighton%20Colorado%20scenic%20agricultural%20landscape%20with%20wide%20open%20plains%20and%20the%20Rocky%20Mountains%20in%20the%20distance%2C%20Barr%20Lake%20State%20Park%20with%20calm%20water%20reflecting%20golden%20sunrise%20light%2C%20historic%20downtown%20Brighton%20with%20tree%20lined%20streets%20and%20small%20town%20charm%2C%20the%20South%20Platte%20River%20corridor%20with%20cottonwood%20trees%2C%20warm%20golden%20hour%20light%20across%20the%20prairie%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20view%20with%20rich%20warm%20tones&width=1800&height=700&seq=brighton-hero-001&orientation=landscape",
  heroImageAlt: "Brighton Colorado with Barr Lake and Rocky Mountain views across the Adams County plains",
  geoPosition: "39.9853;-104.8205",
  geoPlacename: "Brighton, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S. Vaughn Way, Aurora, CO 80014",
    distance: "Approximately 25 miles south via US-85 and I-225 — about 30–40 minutes",
  },
  nearbyCitiesZips: [
    { name: "Brighton", zips: "80601, 80602, 80603" },
    { name: "Commerce City", zips: "80022, 80037" },
    { name: "Fort Lupton", zips: "80621" },
    { name: "Henderson", zips: "80640" },
    { name: "Lochbuie", zips: "80603" },
    { name: "Hudson", zips: "80642" },
    { name: "Keenesburg", zips: "80643" },
    { name: "Thornton", zips: "80241, 80602" },
    { name: "Northglenn", zips: "80233, 80234, 80260" },
    { name: "Westminster", zips: "80031, 80030, 80021" },
    { name: "Reunion", zips: "80602" },
    { name: "Todd Creek", zips: "80602" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Brighton international departures via DEN" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — skip the drive to Aurora, we handle it" },
    { icon: "ri-flight-takeoff-line", title: "DEN Airport Proximity", desc: "DIA is just 20 minutes south — perfect for last-minute international departures" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Brighton, Commerce City, or Thornton" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/cities/denver" },
    { name: "Emergency passport help in Thornton, CO", route: "/cities/thornton" },
    { name: "Fast passport renewal in Adams County area", route: "/cities/brighton" },
    { name: "Urgent passport services for Commerce City", route: "/cities/commerce-city" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Northglenn and Westminster", route: "/cities/northglenn" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Brighton remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Brighton's location along the US-85 corridor — just 25 miles from the Denver Passport Agency — makes our courier service especially convenient. Skip the drive through metro traffic and let us handle everything.",
  fpcOfficeAddress: "3151 S. Vaughn Way, Aurora, CO 80014",
  fpcOfficeDistance: "Serving all of Adams County, southern Weld County, and the US-85/I-76 corridor",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Brighton and the surrounding Adams County area. From Bromley Park and Brighton East Farms to the historic downtown district near the Adams County Courthouse, from the neighborhoods around Brighton High School to the new developments near Prairie Center — we serve every corner of Brighton and the surrounding communities.",
  nearbyCitiesIntro: "We serve Brighton and all nearby communities including Commerce City, Fort Lupton, Henderson, Lochbuie, Hudson, Keenesburg, and the northern Thornton suburbs.",
  howItWorksIntro: "Most Brighton travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to navigate metro Denver traffic to the Aurora passport agency.",
  mistakesIntro: "Brighton is a rapidly growing northern metro community with families, business travelers, and agricultural industry professionals. Here are the most common passport mistakes we see from Brighton-area travelers.",
  testimonialsIntro: "Brighton travelers — from Adams County families to business professionals commuting to Denver — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Brighton, CO? Here are the most common ones we hear from Adams County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Colorado Vital Records (Birth, Death, Marriage)", href: "https://cdphe.colorado.gov/certificates-and-records" },
    { label: "Adams County Clerk & Recorder", href: "https://www.adamscountyco.gov/240/Clerk-Recorder" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (30–40 minutes each way)", "Metro Denver traffic unpredictable"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Aurora drive required — ship from Brighton", "Perfect for international vacations and business trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Brighton travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service available without fighting Denver traffic.",
      bullets: ["24–48 hour turnaround available", "DIA (DEN) departure support", "Business and family travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Brighton adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Adams County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Brighton residents and Adams County families — including new citizens and young adults.",
      bullets: ["Acceptance facility scheduling in Brighton or Thornton", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Brighton residents who lost their passport before international travel or business trips.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Brighton and Adams County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Brighton and Adams County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Brighton CO", description: "Urgent passport processing for Brighton Colorado travelers with immediate departure needs from DEN." },
    { name: "Expedited Passport Renewal Brighton CO", description: "Fast passport renewal for Brighton Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Brighton CO", description: "New passport application services for Brighton Colorado residents applying for their first passport." },
    { name: "Child Passport Brighton CO", description: "Minor passport services for Brighton Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Michael R.",
      location: "Brighton, CO — Bromley Park",
      rating: 5,
      text: "Family trip to Cancun departing from DIA in 5 days. My wife's passport had expired and we panicked. Fast Passport Center got her renewal done in 3 days. Shipped from the UPS Store on Bridge Street and everything went perfectly.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Jennifer S.",
      location: "Brighton, CO — Brighton East Farms",
      rating: 5,
      text: "Business trip to Toronto with 4 days notice. Fast Passport Center handled everything and I had my new passport before the weekend. Being so close to DIA is great — I was able to make my flight no problem.",
      service: "Emergency Passport",
    },
    {
      name: "David L.",
      location: "Fort Lupton, CO",
      rating: 5,
      text: "First-time passport for me and my two kids for a family reunion in Ireland. Fast Passport Center walked us through every step and got all three passports in 6 days. Incredible service for a family.",
      service: "Family Passport Bundle",
    },
    {
      name: "Maria G.",
      location: "Brighton, CO — Downtown",
      rating: 5,
      text: "Lost my passport somewhere between home and DIA — absolute nightmare. Called Fast Passport Center and they had me sorted out in 48 hours. Saved my trip to see family in Mexico City.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "bri-1",
      name: "Brighton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "90 N 4th Ave",
      city: "Brighton",
      state: "CO",
      zip: "80601",
      phone: "(303) 659-3033",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Downtown Brighton, near the Adams County Courthouse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Brighton acceptance facility. Appointments recommended — call ahead. Convenient downtown location near the courthouse.",
      icon: "ri-mail-line",
    },
    {
      id: "bri-2",
      name: "Thornton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8700 Grant St",
      city: "Thornton",
      state: "CO",
      zip: "80229",
      phone: "(303) 853-9940",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 10 miles southwest of Brighton, in Thornton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with extended hours. Good alternative when Brighton appointments are full. Serves the northern metro corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "bri-3",
      name: "Commerce City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7351 Magnolia St",
      city: "Commerce City",
      state: "CO",
      zip: "80022",
      phone: "(303) 288-2725",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 12 miles south of Brighton, in Commerce City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Additional acceptance facility in the Brighton-Commerce City corridor. Convenient for southern Adams County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "bri-4",
      name: "Adams County Clerk & Recorder",
      type: "County Clerk Passport Acceptance",
      address: "4430 S Adams County Pkwy",
      city: "Brighton",
      state: "CO",
      zip: "80601",
      phone: "(720) 523-6100",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Brighton, Adams County Government Center",
      website: "https://www.adamscountyco.gov/",
      websiteLabel: "Adams County Clerk",
      notes: "County clerk passport acceptance at the Adams County Government Center. Extended morning hours. Good for county residents needing full-service processing.",
      icon: "ri-government-line",
    },
    {
      id: "bri-5",
      name: "Fort Lupton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "306 Denver Ave",
      city: "Fort Lupton",
      state: "CO",
      zip: "80621",
      phone: "(303) 857-4100",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 12 miles north of Brighton, in Fort Lupton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northern acceptance facility for southern Weld County residents. Limited hours — call ahead. Small post office with friendly staff.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25-mile drive to Aurora through metro traffic", fpc: "No — ship from Brighton" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Metro Denver Traffic", agency: "Unpredictable I-76/I-270/I-225 congestion", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Brighton's proximity to DIA (20 minutes away) creates a false sense of security. Travelers assume they can handle passport issues last-minute. Routine processing takes 8–11 weeks. Start expedited service at least 4 weeks before travel.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services in Brighton and Commerce City sometimes use incorrect backgrounds or sizing. Passport photos must be exactly 2×2 inches on a white background — no exceptions, no filters.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Brighton Post Office and Adams County Clerk appointments fill during peak travel seasons — summer vacation (June–August) and winter holidays (November–January). Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-car-line",
      title: "Underestimating Metro Denver Traffic",
      description: "Driving from Brighton to the Denver Passport Agency in Aurora means navigating US-85, I-76, I-270, and I-225 — easily 40+ minutes in traffic. Our courier service eliminates this stress entirely.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries require 6 months of passport validity beyond your stay. Brighton travelers heading to Mexico, Canada, or Europe often discover this requirement too late — especially for frequent business travelers.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Assuming DIA Has Walk-in Passport Services",
      description: "Denver International Airport does not have passport processing services. Brighton residents must use acceptance facilities or courier services — there is no airport passport office.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Brighton or Adams County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Brighton, Thornton, or Commerce City." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Adams County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no metro Denver traffic battle required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Brighton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Brighton, CO?", a: "Fast Passport Center offers emergency passport processing in Brighton, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 25-mile drive through metro Denver traffic to the Aurora passport agency." },
    { q: "Does Brighton have its own passport agency?", a: "No — Brighton does not have a regional passport agency. The nearest is the Denver Passport Agency in Aurora (25 miles south via US-85 and I-225). Fast Passport Center's courier service means Brighton residents never need to deal with metro Denver traffic." },
    { q: "Is DIA close enough for last-minute passport processing?", a: "Denver International Airport is approximately 20 minutes from Brighton via E-470, but DIA does not have passport processing services. You need either an acceptance facility appointment or an expedited courier service like Fast Passport Center before your flight." },
    { q: "What if I live in Commerce City, Fort Lupton, or Henderson?", a: "Absolutely. Fast Passport Center serves all of Adams County and southern Weld County including Commerce City, Fort Lupton, Henderson, Lochbuie, Hudson, and Keenesburg. Our service works the same way everywhere — ship your documents and we handle the rest." },
    { q: "Can you help with passports for Brighton's agricultural and business travelers?", a: "Yes. Fast Passport Center serves Brighton's diverse community — from agricultural industry professionals traveling internationally for business to families heading to Mexico or Canada for vacation. We understand the needs of all Adams County travelers." },
    { q: "How much does an expedited passport cost in Brighton, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Brighton?", a: "Walgreens (1821 E Bridge St) and King Soopers (500 E Bromley Ln) offer passport photo services in Brighton. UPS Store locations in Thornton and Commerce City also provide passport photos. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve travelers flying out of DIA?", a: "Yes. Fast Passport Center serves all Brighton and Adams County travelers departing from Denver International Airport (DEN). With DIA just 20 minutes away, we understand the urgency of last-minute international departures and can coordinate expedited services to match your flight schedule." },
  ],
  photoLocations: [
    { name: "Walgreens — Brighton", address: "1821 E Bridge St, Brighton, CO 80601", hours: "Mon–Sun: 8AM–9PM", website: "https://www.walgreens.com/" },
    { name: "King Soopers — Brighton", address: "500 E Bromley Ln, Brighton, CO 80601", hours: "Mon–Sun: 6AM–11PM", website: "https://www.kingsoopers.com/" },
    { name: "UPS Store — Thornton", address: "3901 E 120th Ave, Thornton, CO 80233", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Northglenn", address: "560 E 120th Ave, Northglenn, CO 80233", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Brighton (Adams County)", address: "4430 S Adams County Pkwy, Brighton, CO 80601", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV at the Adams County Government Center. REAL ID and driver's license renewals. Central Brighton location near the courthouse.", featured: true },
    { name: "DMV — Thornton (Adams County)", address: "11940 Colorado Blvd, Thornton, CO 80233", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV in Thornton for northern metro residents. REAL ID processing available. Convenient I-25 access.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "20 miles south via E-470 — approximately 20–25 minutes",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Extremely convenient for Brighton residents — the closest major international airport to Brighton.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "FNL",
      name: "Northern Colorado Regional Airport",
      distance: "40 miles north via I-25 — approximately 40 minutes",
      address: "4900 Earhart Rd, Loveland, CO 80538",
      note: "Regional airport serving Fort Collins and northern Colorado. Limited commercial service. Primarily general aviation. No international flights.",
      flightUrl: "https://www.flynoco.com/",
      flightLabel: "FNL Flight Info",
      featured: false,
    },
  ],
};